import React, { useEffect, useState } from 'react';

import styles from './DogCardUseOverview.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import Card from '../../../../../Shared/Card/Card';
import StatusDot from '../../../../../Shared/StatusDot/StatusDot';

function DogCardUseOverview(props: DogCardUseOverviewProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [dataNumtestsTotal, setNumtestsTotal] = useState<any>("loading ..");
    const [dataNumtestsLeash, setNumtestsLeash] = useState<any>("loading ..");
    const [dataNumtestsLoose, setNumtestsLoose] = useState<any>("loading ..");
    const [dataNumtestsHare, setNumtestsHare] = useState<any>("loading ..");
    const [dataNumtestsBird, setNumtestsBird] = useState<any>("loading ..");
    const [dataNumtestsBirdFetch, setNumtestsBirdFetch] = useState<any>("loading ..");
    const [dataNumtestsDunkerElite, setNumtestsDunkerElite] = useState<any>("loading ..");

    function mapNumtestsToStatusDot(testcount: number | string) {
        if (props.statusDisabled) return null;
        if (testcount == "loading ..") return <StatusDot color="grey" size='md' />;

        if (typeof testcount == "string") return <StatusDot color="grey" size='md' />;
        if (testcount > 0) return <StatusDot color="#68db5a" size='md' />;
        if (testcount == 0) return <StatusDot color="#ffe144" size='md' />;
    }
    
    function getNumtestsLeashData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/leash/count",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setNumtestsLeash(res.data?.[0]?.TESTS_COUNT);
            props.onDataLoaded?.(res.data?.[0]?.TESTS_COUNT);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getNumtestsLooseData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/loose/count",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setNumtestsLoose(res.data?.[0]?.TESTS_COUNT);
            props.onDataLoaded?.(res.data?.[0]?.TESTS_COUNT);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getNumtestsHareData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/hare/count",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setNumtestsHare(res.data?.[0]?.TESTS_COUNT);
            props.onDataLoaded?.(res.data?.[0]?.TESTS_COUNT);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getNumtestsBirdData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/bird/count",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setNumtestsBird(res.data?.[0]?.TESTS_COUNT);
            props.onDataLoaded?.(res.data?.[0]?.TESTS_COUNT);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getNumtestsBirdFetchData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/birdfetch/count",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setNumtestsBirdFetch(res.data?.[0]?.TESTS_COUNT);
            props.onDataLoaded?.(res.data?.[0]?.TESTS_COUNT);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getNumtestsDunkerEliteData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/dunkerelite/count",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setNumtestsDunkerElite(res.data?.ANT_PROVER);
            props.onDataLoaded?.(res.data?.ANT_PROVER);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getNumtestsLeashData();
            getNumtestsLooseData();
            getNumtestsHareData();
            //getNumtestsBirdData();
            //getNumtestsBirdFetchData();
            getNumtestsDunkerEliteData();
        }
    }, [props.dogId]);

    useEffect(() => {
        if (
            dataNumtestsLeash != "loading .." &&
            dataNumtestsLoose != "loading .." &&
            dataNumtestsHare != "loading .." &&
            dataNumtestsBird != "loading .." &&
            dataNumtestsBirdFetch != "loading .."
        ) {
            setNumtestsTotal(dataNumtestsLeash + dataNumtestsLoose + dataNumtestsHare + dataNumtestsBird + dataNumtestsBirdFetch);
            if (dataNumtestsLeash + dataNumtestsLoose + dataNumtestsHare + dataNumtestsBird + dataNumtestsBirdFetch > 0) props.onDataLoaded?.(true);
        } else {
            props.onDataLoaded?.(false);
        }
    }, [dataNumtestsLeash, dataNumtestsLoose, dataNumtestsHare, dataNumtestsBird, dataNumtestsBirdFetch]);

    return (
        <div className={styles.useoverview}>
            <Card
                title={props.title || "Use Overview"}
                children={<div>
                    <hr/>
                    <table className={styles.usetable}>
                        <tbody>
                            {dataNumtestsTotal > 0 && !(dataNumtestsHare > 0) &&
                                <tr>
                                    <td><strong>{t("dog.statistics.areas.use.numtests_total")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataNumtestsTotal}</span>{mapNumtestsToStatusDot(dataNumtestsTotal)}</td>
                                </tr>
                            }
                            {dataNumtestsLeash > 0 &&
                                <tr>
                                    <td><strong>{t("dog.statistics.areas.use.numtests_leash")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataNumtestsLeash}</span>{mapNumtestsToStatusDot(dataNumtestsLeash)}</td>
                                </tr>
                            }
                            {dataNumtestsLoose > 0 &&
                                <tr>
                                    <td><strong>{t("dog.statistics.areas.use.numtests_loose")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataNumtestsLoose}</span>{mapNumtestsToStatusDot(dataNumtestsLoose)}</td>
                                </tr>
                            }
                            {dataNumtestsHare > 0 &&
                                <tr>
                                    <td><strong>{t("dog.statistics.areas.use.numtests_hare")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataNumtestsHare}</span>{mapNumtestsToStatusDot(dataNumtestsHare)}</td>
                                </tr>
                            }
                            {dataNumtestsBird > 0 &&
                                <tr>
                                    <td><strong>{t("dog.statistics.areas.use.numtests_bird")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataNumtestsBird}</span>{mapNumtestsToStatusDot(dataNumtestsBird)}</td>
                                </tr>
                            }
                            {dataNumtestsBirdFetch > 0 &&
                                <tr>
                                    <td><strong>{t("dog.statistics.areas.use.numtests_birdfetch")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataNumtestsBirdFetch}</span>{mapNumtestsToStatusDot(dataNumtestsBirdFetch)}</td>
                                </tr>
                            }
                            {dataNumtestsDunkerElite > 0 &&
                                <tr>
                                    <td><strong>{t("dog.statistics.areas.use.numtests_dunkerelite")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataNumtestsDunkerElite}</span>{mapNumtestsToStatusDot(dataNumtestsDunkerElite)}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>}
            ></Card>
        </div>
    );
}

class DogCardUseOverviewProps {
    title?: string;
    dogId!: string | undefined;
    statusDisabled?: boolean;
    onDataLoaded?: (data: any) => void;
}

export default DogCardUseOverview;